var a = "\\ud800-\\udfff", r = "\\u0300-\\u036f", f = "\\ufe20-\\ufe2f", s = "\\u20d0-\\u20ff", u = r + f + s, o = "\\ufe0e\\ufe0f", n = "\\u200d", d = RegExp("[" + n + a + u + o + "]");
function g(e) {
  return d.test(e);
}
export {
  g as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_hasUnicode.js
// module id = 878
// module chunks = 41